<template>
	<v-navigation-drawer
    class="my-elevation-2 index-5"
    v-model="extraSidebar.sidebarDrawer"
		app
		floating
		disable-resize-watcher
		right
    width="260"
  >
		<component :is="extraSidebar.compSidebar"/>
	</v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'
export default {
	computed: {
		...mapState(['extraSidebar'])
	}
}
</script>
